import { createAction } from 'redux-act';
export var openDialog = createAction("open dialog");
export var closeDialog = createAction("close dialog");
export var showMessage = createAction("show message");
export var hideMessage = createAction("close dialog");
export var logIn = createAction("log in");



//////////////////
// WEBPACK FOOTER
// ./src/app-ducks/actions.ts
// module id = 80
// module chunks = 0